import type * as React from 'react';

import { Toaster as Sonner, type ToasterProps } from 'sonner';

import { cn } from '../lib/utils';
import { useTheme } from '../providers/theme-provider';

function Toaster({ toastOptions, ...props }: ToasterProps) {
    const { theme = 'system' } = useTheme();
    const userClassNames = toastOptions?.classNames;

    return (
        <Sonner
            position="top-right"
            theme={theme as ToasterProps['theme']}
            className="group"
            toastOptions={{
                ...toastOptions,
                classNames: {
                    ...userClassNames,
                    toast: cn(
                        'font-sans text-base text-foreground min-w-0 !w-fit',
                        userClassNames?.toast,
                    ),
                    description: cn('text-sm !text-muted-foreground', userClassNames?.description),
                    success: cn('[&_[data-icon]]:text-toast-success', userClassNames?.success),
                    error: cn('[&_[data-icon]]:text-destructive', userClassNames?.error),
                    info: cn('[&_[data-icon]]:text-toast-info', userClassNames?.info),
                    warning: cn('[&_[data-icon]]:text-toast-warning', userClassNames?.warning),
                    actionButton: cn(
                        '!bg-primary !text-primary-foreground border-none rounded px-2 py-0 text-sm font-medium leading-[1.3] shadow-sm transition-all duration-200 ease-in-out hover:!bg-primary/80',
                        userClassNames?.actionButton,
                    ),
                    cancelButton: cn(
                        '!bg-secondary !text-secondary-foreground border-none rounded px-2 py-0 text-sm font-medium leading-[1.3] shadow-sm transition-all duration-200 ease-in-out hover:!bg-secondary/80',
                        userClassNames?.cancelButton,
                    ),
                },
            }}
            style={
                {
                    '--normal-bg': 'var(--background)',
                    '--normal-text': 'var(--popover-foreground)',
                    '--normal-border': 'var(--border)',
                } as React.CSSProperties
            }
            {...props}
        />
    );
}

export { Toaster };
